import {
	differenceInDays,
	differenceInMonths,
	differenceInYears,
	endOfWeek,
	format,
	startOfWeek,
} from "date-fns";
import { DaylogStatus } from "../validators/grouped-day-attendance.dto";

export const base64toBlob = async (base64Data: string) => {
	const pureBase64 = base64Data.split(",")[1];

	const byteCharacters = atob(pureBase64);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	const blob = new Blob([byteArray], { type: "image/png" });

	const imageUrl = URL.createObjectURL(blob);

	return imageUrl;
};

export const getWeekDates = () => {
	const today = new Date();

	const weekStart = startOfWeek(today, { weekStartsOn: 0 });
	const weekEnd = endOfWeek(today, { weekStartsOn: 0 });

	return { start: weekStart, end: weekEnd };
};

export const calendarDate = ({
	date,
	dateFormat = "dd, MMMM yyyy",
}: {
	date: Date;
	dateFormat?: string;
}) => {
	let formatDate = format(date, dateFormat);
	let from = format(date, "yyyy-MM-dd 00:00:00");
	let to = format(date, "yyyy-MM-dd 23:59:59");

	formatDate = `${format(
		startOfWeek(date, { weekStartsOn: 1 }),
		dateFormat
	)} - ${format(endOfWeek(date, { weekStartsOn: 1 }), dateFormat)}`;

	from = format(startOfWeek(date), "yyyy-MM-dd 00:00:00");
	to = format(endOfWeek(date, { weekStartsOn: 1 }), "yyyy-MM-dd 23:59:59");

	return {
		formatDate,
		// from: new Date(from).toISOString(),
		from,
		to,
		// to: new Date(to).toISOString(),
	};
};

export const msToHMS = (duration: number) => {
	let minutes = Math.round((duration / (1000 * 60)) % 60);
	let hours = Math.round(duration / (1000 * 60 * 60));

	return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
};

export const formatFileSize = (fileSize: number) => {
	if (fileSize < 1024) {
		return `${fileSize} B`;
	} else if (fileSize < 1024 * 1024) {
		return `${(fileSize / 1024).toFixed(2)} KB`;
	} else {
		return `${(fileSize / (1024 * 1024)).toFixed(2)} MB`;
	}
};

export const _renderBadge = (status: DaylogStatus) => {
	let objStatus;
	switch (status) {
		case DaylogStatus.pending:
			return (objStatus = {
				label: "No Attendance",
				background: "bg-opus-gray-300",
			});

		case DaylogStatus.onLeave:
			return (objStatus = {
				label: "On Leave",
				background: "bg-opus-yellow-200",
			});
		case DaylogStatus.present:
			return (objStatus = {
				label: "Present",
				background: "bg-opus-green-200",
			});

		default:
			return (objStatus = {
				label: "Unavailable",
				background: "bg-opus-gray-700",
			});
	}
};

export const formatDateRange = (startDate: string, endDate: string) => {
	const startMonth = format(new Date(startDate), "MMMM");
	const startDay = format(new Date(startDate), "d");
	const endDay = format(new Date(endDate), "d");
	const displayDate =
		startDate !== endDate
			? `${startMonth} ${startDay}-${endDay}`
			: `${startMonth} ${startDay}`;
	return displayDate;
};

export const _renderStatus = (status: boolean | null) => {
	let objStatus;
	switch (status) {
		case false:
			return (objStatus = {
				label: "Denied",
				background: "bg-opus-red-100",
			});
		case true:
			return (objStatus = {
				label: "Approved",
				background: "bg-opus-green-200",
			});

		default:
			return (objStatus = {
				label: "Pending",
				background: "bg-opus-gray-700",
			});
	}
};

export const formatEventDateRange = (startDate: string, endDate: string) => {
	const startDateFormat = format(startDate, "EEEE, MMMM d"); // e.g., "Friday, June 21"
	const startTimeFormat = format(startDate, "h:mm a"); // e.g., "8:00 AM"
	const endTimeFormat = format(endDate, "h:mm a"); // e.g., "8:30 AM"

	return `${startDateFormat}. ${startTimeFormat}-${endTimeFormat}`;
};

export const convertHireDate = (date: string) => {
	const targetDate = new Date(date);
	const now = new Date();

	const years = differenceInYears(now, targetDate);
	const months = differenceInMonths(now, targetDate) % 12;
	const days =
		differenceInDays(
			now,
			targetDate.setFullYear(
				targetDate.getFullYear() + years,
				targetDate.getMonth() + months
			)
		) % 30;

	const parts = [];
	if (years > 0) parts.push(`${years}y`);
	if (months > 0) parts.push(`${months}m`);
	if (days > 0) parts.push(`${days}d`);

	const durationString = parts.length > 0 ? parts.join(" - ") : "0d";

	return durationString;
};

export const roundNumber = (num: number): number => {
	return Math.round(num);
};

export const roundToDemical = (num: number, decimals: number): number => {
	return parseFloat(num.toFixed(decimals));
};
